export { fromEvent } from './file-selector';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/file-selector/dist/es5/index.js
// module id = 1412
// module chunks = 0